import React from 'react';
export default {
	Text: [
		'MyKinWallet helps you easily interact with the Kin blockchain. It is an open-source, client-side tool and service that helps the user handle their Kin coins and move them between wallets.',
		<div>
			In order to use MyKinWallet you need to obtain a supported wallet (see the list of Kin-supported wallets at -{' '}
			<a target="_blank" rel="noreferrer" href="https://www.kin.org/token-migration/" style={{ color: 'white', textDecoration: 'underline' }}>
				https://www.kin.org/token-migration
			</a>
			)
		</div>
	]
};
